var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgControlIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 6.75141H19.5M4.5 6.75141H6.75M17.25 12.0014H19.5M4.5 12.0014H12.75M12.75 17.2514H19.5M4.5 17.2514H8.25M10.875 6.69141C10.8715 7.19324 10.6747 7.67442 10.3254 8.03482C9.97622 8.39523 9.50148 8.60712 9 8.62641C8.49852 8.60712 8.02378 8.39523 7.67455 8.03482C7.32532 7.67442 7.12849 7.19324 7.125 6.69141C7.125 6.19413 7.32254 5.71721 7.67417 5.36558C8.02581 5.01395 8.50272 4.81641 9 4.81641C9.49728 4.81641 9.97419 5.01395 10.3258 5.36558C10.6775 5.71721 10.875 6.19413 10.875 6.69141ZM16.875 11.9414C16.875 12.4387 16.6775 12.9156 16.3258 13.2672C15.9742 13.6189 15.4973 13.8164 15 13.8164C14.5027 13.8164 14.0258 13.6189 13.6742 13.2672C13.3225 12.9156 13.125 12.4387 13.125 11.9414C13.125 11.4441 13.3225 10.9672 13.6742 10.6156C14.0258 10.264 14.5027 10.0664 15 10.0664C15.4973 10.0664 15.9742 10.264 16.3258 10.6156C16.6775 10.9672 16.875 11.4441 16.875 11.9414ZM12.375 17.1914C12.3715 17.6932 12.1747 18.1744 11.8254 18.5348C11.4762 18.8952 11.0015 19.1071 10.5 19.1264C9.99852 19.1071 9.52378 18.8952 9.17455 18.5348C8.82532 18.1744 8.62849 17.6932 8.625 17.1914C8.625 16.6941 8.82254 16.2172 9.17417 15.8656C9.52581 15.514 10.0027 15.3164 10.5 15.3164C10.9973 15.3164 11.4742 15.514 11.8258 15.8656C12.1775 16.2172 12.375 16.6941 12.375 17.1914Z",
    stroke: "#5E6C84",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlIcon);
export default __webpack_public_path__ + "static/media/control_icon.ebe82d0b5f7309d2efc70be14bd82ed8.svg";
export { ForwardRef as ReactComponent };